const AFFILIATION = 'TKRS';
const CATALOG_PLP_INTERACTION = 'Transactional Catalog PLP interaction';
const CLICK_TO_SEE_MORE = 'click to see more';
const CURRENCY_CODE = 'USD';
const SEARCH_RESULTS_LIST_ID = 'search-results';
const SEARCH_RESULTS_PLP_TYPE = 'search results';
const SEARCH_RESULTS_PAGE_NAME = 'Search Results Page';
const SEARCH_RESULTS_VIEW_SELECTION = 'view search result';
const PRODUCT_CLASS_SEARCH_LIST_ID = 'product_class_search_plp';
const SEARCH_PAGE_LIST_ID_MAPPER = {
  complementary_rec: PRODUCT_CLASS_SEARCH_LIST_ID,
};
const SORY_BY_SELECTION = 'sort by';

export {
  AFFILIATION,
  CATALOG_PLP_INTERACTION,
  CLICK_TO_SEE_MORE,
  CURRENCY_CODE,
  PRODUCT_CLASS_SEARCH_LIST_ID,
  SEARCH_RESULTS_LIST_ID,
  SEARCH_RESULTS_PAGE_NAME,
  SEARCH_RESULTS_VIEW_SELECTION,
  SEARCH_RESULTS_PLP_TYPE,
  SEARCH_PAGE_LIST_ID_MAPPER,
  SORY_BY_SELECTION,
};
